module.exports = __webpack_public_path__ + "img/j1.39b44c00.png";